<h2 class="wizard_step-title text--title-bold">{{ 'patient' | translate | titlecase }}</h2>

<div class="device-mode-cards">
  <div
    class="device-mode-card"
    [ngClass]="{ 'device-mode-card--active': mode === 'existing' }"
    (click)="setMode('existing')">
    <i class="fas fa-user device-mode-card_icon"></i>
    <span class="device-mode-card_label">{{ 'useExistingPatient' | translate }}</span>
  </div>
  <div
    class="device-mode-card"
    [ngClass]="{ 'device-mode-card--active': mode === 'new' }"
    (click)="setMode('new')">
    <i class="fas fa-user-plus device-mode-card_icon"></i>
    <span class="device-mode-card_label">{{ 'createNewPatient' | translate }}</span>
  </div>
</div>

<!-- Assign existing patient -->
<ng-container *ngIf="mode === 'existing'">
  <app-input-wrapper [control]="patientControl" label="{{ 'patient' | translate }}">
    <input
      class="form_control"
      type="text"
      [formControl]="patientControl"
      [matAutocomplete]="auto"
      placeholder="{{ 'search' | translate }}"
      aria-label="{{ 'patient' | translate }}">
    <mat-autocomplete #auto="matAutocomplete" class="dropdown dropdown--autocomplete">
      <mat-option
        *ngFor="let patient of patients"
        [value]="getPatientName(patient)"
        (onSelectionChange)="onSelectExisting(patient)">
        {{ getPatientLabel(patient) }}
      </mat-option>
    </mat-autocomplete>
  </app-input-wrapper>

  <div class="wizard_footer wizard_footer--single">
    <button class="button button--primary form_button" type="button" [disabled]="!canProceed" (click)="onNext()">
      <span class="regular">{{ 'next' | translate }}</span>
    </button>
  </div>
</ng-container>

<!-- Create new patient -->
<form *ngIf="mode === 'new' && form" [formGroup]="form" (ngSubmit)="onNext()">
  <app-input-wrapper
    [control]="form.get('doctor')"
    label="{{ 'doctorsName' | translate }}">
    <mat-select
      class="form_control"
      formControlName="doctor"
      disableOptionCentering
      panelClass="dropdown"
      name="doctor"
      aria-label="{{ 'doctorsName' | translate }}">
      <mat-option *ngFor="let doctor of doctors" [value]="doctor.id">
        {{ doctor.first_name + ' ' + doctor.last_name }}
      </mat-option>
    </mat-select>
  </app-input-wrapper>

  <app-input-wrapper
    *ngIf="!preferences?.disable_pi && !authService.isClinicalTrialReadOnlyNoPii"
    [control]="form.get('first_name')"
    label="{{ 'firstName' | translate }}"
    identifier="first_name">
    <input class="form_control" type="text" formControlName="first_name" name="first_name" id="first_name">
  </app-input-wrapper>

  <app-input-wrapper
    *ngIf="!preferences?.disable_pi && !authService.isClinicalTrialReadOnlyNoPii"
    [control]="form.get('last_name')"
    label="{{ 'lastName' | translate }}"
    identifier="last_name">
    <input class="form_control" type="text" formControlName="last_name" name="last_name" id="last_name">
  </app-input-wrapper>

  <app-input-wrapper
    *ngIf="!preferences?.disable_pi && !authService.isClinicalTrialReadOnlyNoPii"
    [control]="form.get('date_of_birth')"
    label="{{ 'dateOfBirth' | translate }}"
    identifier="date_of_birth">
    <input
      class="form_control"
      [matDatepicker]="picker"
      [datePickerFormat]="preferencesService.defaultDateFormat.serverValue"
      [max]="maxDobDate"
      formControlName="date_of_birth"
      name="date_of_birth"
      id="date_of_birth">
    <mat-datepicker-toggle
      matSuffix
      [for]="picker"
      class="form_datepicker-icon">
    </mat-datepicker-toggle>
  </app-input-wrapper>

  <mat-datepicker #picker></mat-datepicker>

  <app-input-wrapper
    *ngIf="preferences?.disable_pi && !authService.isClinicalTrialReadOnlyNoPii"
    [control]="form.get('date_of_birth')"
    label="{{ 'yearOfBirth' | translate }}">
    <input
      name="year_of_birth"
      class="form_control"
      type="number"
      min="1900"
      [max]="maxYearOfBirth"
      formControlName="date_of_birth">
  </app-input-wrapper>

  <app-input-wrapper
    *ngIf="preferences?.disable_pi || authService.isClinicalTrialReadOnlyNoPii"
    [control]="form.get('patient_id_number')"
    label="{{ 'patientIdNumber' | translate }}"
    identifier="patient_id_number">
    <input class="form_control" type="text" formControlName="patient_id_number" name="patient_id_number" id="patient_id_number">
  </app-input-wrapper>

  <div class="wizard_footer wizard_footer--single">
    <button class="button button--primary form_button" type="submit" [disabled]="!form.valid">
      <span class="regular">{{ 'next' | translate }}</span>
    </button>
  </div>
</form>

<app-loader *ngIf="isLoading"></app-loader>
